const {
    GET_COMPANY_TAGS_REQUEST,
    GET_COMPANY_TAGS_SUCCESS,
    GET_COMPANY_TAGS_FAILURE,

    FILTER_COMPANY_TAGS_REQUEST,
    FILTER_COMPANY_TAGS_SUCCESS,
    FILTER_COMPANY_TAGS_FAILURE,

    CREATE_TAG_REQUEST,
    CREATE_TAG_SUCCESS,
    CREATE_TAG_FAILURE,

    DELETE_TAG_REQUEST,
    DELETE_TAG_SUCCESS,
    DELETE_TAG_FAILURE,
} = require('./companyTagActions').constants;

const tagInitialState = {
    tagList: [],
    filteredTagList: [],
    pagination: {
        currentPage: 1,
        totalRecords: 0,
        pageCount: 0,
        perPageCount: 20,
    },
    fetchingTags: false,
    tagsError: null,
};

export default function companyTagsReducer(state = tagInitialState, action) {
    switch (action.type) {
        case GET_COMPANY_TAGS_REQUEST:
        case FILTER_COMPANY_TAGS_REQUEST:
        case CREATE_TAG_REQUEST:
        case DELETE_TAG_REQUEST:
            return {
                ...state,
                fetchingTags: true,
                tagsError: null,
            };

        case GET_COMPANY_TAGS_SUCCESS:
            return {
                ...state,
                fetchingTags: false,
                tagList: action.payload,
            };

        case FILTER_COMPANY_TAGS_SUCCESS:
            const pagination = {};
            pagination.currentPage = action.payload.headers['x-pagination-current-page'] || 1;
            pagination.totalRecords = action.payload.headers['x-pagination-total-count'] || 0;
            pagination.pageCount = action.payload.headers['x-pagination-page-count'] || 0;
            pagination.perPageCount = action.payload.headers['x-pagination-per-page'] || 10;
            return {
                ...state,
                fetchingTags: false,
                filteredTagList: action.payload.data,
                pagination,
            };

        case CREATE_TAG_SUCCESS:
            return {
                ...state,
                fetchingTags: false,
                tagList: [...state.tagList, action.payload],
            };

        case DELETE_TAG_SUCCESS:
            return {
                ...state,
                fetchingTags: false,
                tagList: state.tagList.filter(tag => tag.id !== action.payload),
            };

        case GET_COMPANY_TAGS_FAILURE:
        case FILTER_COMPANY_TAGS_FAILURE:
        case CREATE_TAG_FAILURE:
        case DELETE_TAG_FAILURE:
            return {
                ...state,
                fetchingTags: false,
                tagsError: action.payload,
            };

        default:
            return state;
    }
}

export {
    companyTagsReducer,
    tagInitialState,
};